module.exports = __webpack_public_path__ + "static/media/delete-document.42915ecf.svg";